module.exports = __webpack_public_path__ + "img/canbadge_egg_w46mm_line.665bc7a7.png";